import React from 'react';

interface SaveProgressProps {
  current: number;
  total: number;
}

export function SaveProgress({ current, total }: SaveProgressProps) {
  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Saving Dataset</h3>
        <div className="space-y-4">
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div 
              className="bg-indigo-600 h-2.5 rounded-full transition-all duration-300"
              style={{ width: `${(current / total) * 100}%` }}
            />
          </div>
          <p className="text-sm text-gray-600 text-center">
            Saving {current} of {total} transactions
          </p>
        </div>
      </div>
    </div>
  );
}